import { Box, Typography, useTheme } from "@mui/material";
import Tags from "lib/components/tags/Tags";
import { sxStyles } from "./AppointmentDetailsNoticePanel.styles";
import { AppointmentDetailsNoticePanelProps } from "./AppointmentDetailsNoticePanel.types";

const AppointmentDetailsNoticePanel = ({
  detailsList,
  tagLabel,
  tagColorChoice,
}: AppointmentDetailsNoticePanelProps) => {
  const theme = useTheme();
  const classes = sxStyles(theme);

  return (
    <>
      <Box sx={classes.container}>
        <Box sx={classes.leftPanel}>
          {detailsList.map((slot, index) => {
            return (
              <Box key={index}>
                {slot.map((line, index) => {
                  return (
                    <Typography key={index} sx={classes.detailsText}>
                      {line}
                    </Typography>
                  );
                })}
              </Box>
            );
          })}
        </Box>
        <Box>
          <Tags label={tagLabel} colorChoice={tagColorChoice} />
        </Box>
      </Box>
    </>
  );
};

export default AppointmentDetailsNoticePanel;
